import { startPositTrnsSvc } from '@/utils/positTrns'
import { useCMSYAUTHstore } from '@/service/stores/cm/cmsy/AUTH.store'
import { useDLLG01V101Store } from '@/service/stores/dl/dllg/DLLG-01-V101.store'
import { datadogRum } from '@datadog/browser-rum'

/** 구동 시점 앱 초기화 */
export const doApplInitBegin = async () => {
  const CMSYAUTHstore = useCMSYAUTHstore()
  await CMSYAUTHstore.actionHttpAllMsgList()
}

/** 로그인 시점 앱 초기화 */
export const doApplInitLogin = async ({ isShowErr }) => {
  const CMSYAUTHstore = useCMSYAUTHstore()

  const userInfoResponse = await retrieveUserInfo({ isShowErr })
  if (userInfoResponse == null) {
    return false
  }

  const inqJoinCd = userInfoResponse.data.sessionDeliveryData.joinCd
  const loginInfoResponse = await retrieveLoginInfo({ inqJoinCd, isShowErr })
  if (loginInfoResponse == null) {
    return false
  }

  const loginInfo = loginInfoResponse.data

  CMSYAUTHstore.user.userId = userInfoResponse.data.sessionUserId
  CMSYAUTHstore.user.userNm = loginInfo.empNm
  CMSYAUTHstore.user.carNo = loginInfo.carNo
  CMSYAUTHstore.user.suppNm = loginInfo.suppNm
  CMSYAUTHstore.user.strNm = loginInfo.strNm
  CMSYAUTHstore.user.joinCd = inqJoinCd

  datadogRum.setUser({
    id: loginInfo.userId,
    name: loginInfo.empNm,
    email: userInfoResponse.data.sessionEmailAddr
  })

  await $nvBridge.deviceInfo.setDatadogUserInfo({
    id: loginInfo.userId,
    name: loginInfo.empNm,
    email: userInfoResponse.data.sessionEmailAddr
  })

  startPositTrnsSvc({
    joinCd: inqJoinCd,
    beginTime: parseTime(userInfoResponse.data.sessionDeliveryData.beginTime),
    endTime: parseTime(userInfoResponse.data.sessionDeliveryData.endTime)
  })

  await CMSYAUTHstore.actionHttpHoliday()
  await CMSYAUTHstore.actionHttpAllMsgList()

  return true
}

const retrieveUserInfo = async ({ isShowErr }) => {
  const DLLG01V101Store = useDLLG01V101Store()
  let response
  try {
    response = await DLLG01V101Store.actionHttpSuppMoDlLgLoginRetrieveUserInfo()
  } catch {
    return await initErr(isShowErr, '로그인 정보가 존재하지 않습니다.')
  }

  if (response.meta.code !== '0000') {
    return await initErr(isShowErr, '로그인 정보가 존재하지 않습니다.')
  }
  return response
}

const retrieveLoginInfo = async ({ inqJoinCd, isShowErr }) => {
  const DLLG01V101Store = useDLLG01V101Store()
  let response
  try {
    response = await DLLG01V101Store.actionHttpSuppMoDlMrDlvyJoinRetrieveDlvyLoginInfo({
      joinCd: inqJoinCd
    })
  } catch {
    return await initErr(isShowErr, '로그인 정보가 존재하지 않습니다.')
  }

  if (response.meta.code !== '0000' || response.data == null) {
    return await initErr(isShowErr, '로그인 정보가 존재하지 않습니다.')
  }

  const loginInfo = response.data
  if (loginInfo.useYn === 'N') {
    return await initErr(isShowErr, '로그인 할 수 없습니다. <br>관리자에게 문의하십시오.')
  }
  if (loginInfo.dworkYn === 'N') {
    return await initErr(isShowErr, '사용 기간이 아닙니다. <br>관리자에게 문의하십시오.')
  }

  return response
}

const initErr = async (isShowErr, msg) => {
  if (isShowErr) {
    await $msg.showMessage('type01', msg)
  }
  return null
}

const parseTime = (timeStr) => {
  return Number(timeStr + '00')
}
